var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClient from '@utils/api-client';
export function connectCredentials(url, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.post(url, payload);
        return response.data;
    });
}
export function disconnectCredentials(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.delete(url);
        return response.data.credentialStatus;
    });
}
export function rerunChecklist(urls) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.post(urls.checklist);
        return response.data.verification;
    });
}
export function startBulkPull(urls, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.post(urls.startBulkPull, options);
        return response.data.pullSummary;
    });
}
export function fetchStatus(urls) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(urls.status);
        return { pullSummary: response.data.pullSummary, bulkPullRunning: response.data.bulkPullRunning };
    });
}
export function dismissPullFailure(urls) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.post(urls.dismissPullFailure);
        return response.data.pullSummary;
    });
}
export function fetchRecentFailures(urls) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(urls.recentFailures);
        return response.data;
    });
}
export function resendFailure(urls, recordId, reason) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.post(urls.resend, { serviceTitanJobId: recordId, reason });
    });
}
export function saveEquipmentTypeMap(urls, equipmentTypeMap) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.patch(urls.updateEquipmentConfig, { equipmentTypeMap });
        return response.data.equipmentConfig.equipmentTypeMap;
    });
}
export function ignoreEquipmentType(urls, type) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.post(urls.ignoreEquipmentType, type);
    });
}
export function unignoreEquipmentType(urls, stEquipmentTypeId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.delete(urls.unignoreEquipmentType, { params: { stEquipmentTypeId } });
        return response.data.ignoredEquipmentTypes;
    });
}
